/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

// All fleet vehicles (matches sendo tracker VEHICLES array)
const VEHICLES = [
  "KA01AE8482","KA01AF8611","KA01AM6327","KA01AM6328","KA01AM6329","KA01AM6330",
  "KA01AM6331","KA01AR0996","KA01AR0997","KA02C6247","KA03AH4987","KA04AC1128",
  "KA04AC1182","KA06AA0880","KA09C1390","KA20A6593","KA20D0564","KA41D4863",
  "KA51AC8745","KA51AG7183","KA51AH5365","KA51AH5366","KA51AH5457","KA51AH8375",
  "KA51AH8379","KA51AJ4011","KA51AK4010","KA51AK4936","KA51AK4937","KA51AK4938",
  "KA51AK4939","KA51AK4940","KA51AK4941","KA51AK4942","KA51AK4943","KA51AK4944",
  "KA51AK4945","KA51AL7240","KA51AL7241","KA51AL7242","KA51AL7243","KA51AL7244",
  "KA51AM2815","KA53A7588","NEW 17FT","NEW 20FT","NEW 20FT 8416","NEW VEHICLE"
];

const VTYPES = ["", "Pickup Truck", "407 Truck", "17FT", "20FT"];

const EMPTY_ROW = (v) => ({ vehicle: v, vtype: "", interval: "", litres: "", kmPerLitre: "", expectedKm: "", actualKm: "" });

export default function EmployeeScheduleConfig() {
  const [rows, setRows]       = useState(VEHICLES.map(EMPTY_ROW));
  const [search, setSearch]   = useState("");
  const [_saved, setSaved]     = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus]   = useState("");

  // Load from backend / localStorage on mount
  useEffect(() => {
    const local = localStorage.getItem("fleetScheduleConfig");
    if (local) {
      try {
        const cfg = JSON.parse(local);
        setRows(VEHICLES.map(v => ({ ...EMPTY_ROW(v), ...(cfg[v] || {}) })));
      } catch (e) {}
    }
    fetchFromBackend();
  }, []);

  const fetchFromBackend = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/schedule`);
      const cfg = res.data?.data || res.data || {};
      if (cfg && typeof cfg === "object") {
        setRows(prev => prev.map(r => ({ ...r, ...(cfg[r.vehicle] || {}) })));
      }
    } catch (e) { /* use local */ }
  };

  const handleChange = (vehicle, field, value) => {
    setRows(prev => prev.map(r => r.vehicle === vehicle ? { ...r, [field]: value } : r));
  };

  const handleSaveAll = async () => {
    setLoading(true);
    // Build config object keyed by vehicle
    const cfg = {};
    rows.forEach(r => { cfg[r.vehicle] = { ...r }; });
    // Persist to localStorage
    localStorage.setItem("fleetScheduleConfig", JSON.stringify(cfg));
    // Persist to backend
    try {
      await axios.post(`${API_BASE_URL}/api/schedule`, cfg);
    } catch (e) { /* local save still works */ }
    setSaved(true);
    setStatus("✅ Schedule saved for all vehicles!");
    setTimeout(() => { setSaved(false); setStatus(""); }, 3000);
    setLoading(false);
  };

  const handleClearAll = () => {
    if (!window.confirm("Clear ALL schedule configs?")) return;
    setRows(VEHICLES.map(EMPTY_ROW));
    localStorage.removeItem("fleetScheduleConfig");
    setStatus("🗑 All schedules cleared.");
    setTimeout(() => setStatus(""), 3000);
  };

  const handleClearRow = (vehicle) => {
    setRows(prev => prev.map(r => r.vehicle === vehicle ? EMPTY_ROW(vehicle) : r));
  };

  const filtered = rows.filter(r =>
    r.vehicle.toLowerCase().includes(search.toLowerCase())
  );

  const S = {
    container: { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    body:      { padding: "20px" },
    toolbar:   { display: "flex", gap: 10, alignItems: "center", marginBottom: 16, flexWrap: "wrap" },
    input:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    select:    { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, background: "#fff" },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "10px 22px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:  { background: "#000", color: "#fff", border: "none", padding: "10px 22px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnRed:    { background: "transparent", border: "1px solid #c0392b", color: "#c0392b", padding: "4px 8px", borderRadius: 5, cursor: "pointer", fontSize: 11 },
    table:     { width: "100%", borderCollapse: "collapse" },
    thB:       { background: "#000", color: "#fff", padding: "12px 10px", textAlign: "center", fontSize: 12, fontWeight: "bold", whiteSpace: "nowrap" },
    td:        { border: "1px solid #ccc", padding: "6px 8px", textAlign: "center", fontSize: 12, color: "#000" },
    cellInput: { padding: "5px 7px", border: "1px solid #ccc", borderRadius: 4, fontSize: 12, width: "80px", textAlign: "center", fontFamily: "Arial, sans-serif" },
    cellSel:   { padding: "5px 7px", border: "1px solid #ccc", borderRadius: 4, fontSize: 12, background: "#fff", fontFamily: "Arial, sans-serif" },
    infoBox:   { background: "#fff8e1", border: "1px solid #f59e0b", borderRadius: 6, padding: "10px 14px", fontSize: 13, marginBottom: 14, color: "#555" },
    status:    { background: "#e6f9ee", border: "1px solid #27ae60", color: "#27ae60", padding: "10px 14px", borderRadius: 6, fontSize: 13 },
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Schedule Configuration</h2>
      <div style={S.body}>
        <div style={S.infoBox}>
          ⏱ Set fill interval, litres schedule, and mileage (KM/Fill + KM/L) for all vehicles at once. Changes apply to the Dashboard immediately.
        </div>

        <div style={S.toolbar}>
          <input style={S.input} placeholder="Search vehicle..." value={search} onChange={e => setSearch(e.target.value)} />
          <span style={{ fontSize: 13, color: "#555" }}>{filtered.length} vehicles</span>
          <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
            <button style={S.btnYellow} onClick={handleSaveAll} disabled={loading}>
              {loading ? "Saving..." : "✅ Save All Schedule Changes"}
            </button>
            <button style={S.btnBlack} onClick={handleClearAll}>🗑 Clear All Schedules</button>
          </div>
        </div>

        {status && <div style={{ ...S.status, marginBottom: 14 }}>{status}</div>}

        <div style={{ overflowX: "auto" }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.thB}>Vehicle</th>
                <th style={S.thB}>Type</th>
                <th style={S.thB}>Fill Interval (days)</th>
                <th style={S.thB}>Litres / Fill</th>
                <th style={S.thB}>KM per Litre</th>
                <th style={S.thB}>Expected KM</th>
                <th style={S.thB}>Actual KM</th>
                <th style={S.thB}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <tr key={r.vehicle} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                  <td style={{ ...S.td, textAlign: "left", fontFamily: "monospace", fontWeight: "bold", whiteSpace: "nowrap", paddingLeft: 10 }}>
                    {r.vehicle}
                  </td>
                  <td style={S.td}>
                    <select style={S.cellSel} value={r.vtype} onChange={e => handleChange(r.vehicle, "vtype", e.target.value)}>
                      {VTYPES.map(t => <option key={t}>{t}</option>)}
                    </select>
                  </td>
                  <td style={S.td}>
                    <input style={S.cellInput} type="number" min="1" placeholder="—"
                      value={r.interval} onChange={e => handleChange(r.vehicle, "interval", e.target.value)} />
                  </td>
                  <td style={S.td}>
                    <input style={S.cellInput} type="number" min="0" step="0.1" placeholder="—"
                      value={r.litres} onChange={e => handleChange(r.vehicle, "litres", e.target.value)} />
                  </td>
                  <td style={S.td}>
                    <input style={S.cellInput} type="number" min="0" step="0.01" placeholder="—"
                      value={r.kmPerLitre} onChange={e => handleChange(r.vehicle, "kmPerLitre", e.target.value)} />
                  </td>
                  <td style={S.td}>
                    <input style={S.cellInput} type="number" min="0" placeholder="—"
                      value={r.expectedKm} onChange={e => handleChange(r.vehicle, "expectedKm", e.target.value)} />
                  </td>
                  <td style={S.td}>
                    <input style={S.cellInput} type="number" min="0" placeholder="—"
                      value={r.actualKm} onChange={e => handleChange(r.vehicle, "actualKm", e.target.value)} />
                  </td>
                  <td style={S.td}>
                    <button style={S.btnRed} onClick={() => handleClearRow(r.vehicle)}>Clear</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          <button style={S.btnYellow} onClick={handleSaveAll} disabled={loading}>
            {loading ? "Saving..." : "✅ Save All Schedule Changes"}
          </button>
          <button style={S.btnBlack} onClick={handleClearAll}>🗑 Clear All Schedules</button>
        </div>
      </div>
    </div>
  );
}
